<template>
  <div class="pagemain">
    <div style="height: 30px"></div>
    <div class="bind2" v-if="submit_status == 0">
      <Icon type="ios-time" size="50" color="#e7ec41" />
      <div class="bind2_name">绑定中，请稍等片刻！</div>
    </div>
    <div class="bind2" v-if="submit_status == 1">
      <Icon type="md-checkmark-circle" size="50" color="#0466dd" />
      <div class="bind2_name">恭喜您，绑定微信成功！</div>
    </div>
    <div class="bind2" v-if="submit_status == 2">
      <Icon type="md-close-circle" size="50" color="red" />
      <div class="bind2_name">{{ submit_error_txt }}</div>
    </div>
    <!-- <div class="bind_wx_title">
      您正在为大象系统绑定微信，绑定后系统通知可通过公众号收到，点击下方【确认绑定：
      <br /><br />
      1、确认授权昵称头像 <br />
      2、点击确认绑定
    </div> -->
    <!-- <div class="bind_btn_div">
      <Button
        type="primary"
        class="bind_btn"
        style="width: 300px"
        :loading="submit_loading"
        @click="click_bind()"
        >确认绑定</Button
      >
    </div> -->

    <div class="logo2_div">
      <img src="@/assets/image/auth/logo.png" alt="" class="logo2" />
    </div>
    <Spin fix v-if="!query"
      ><Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>玩命加载中</div>
    </Spin>
    <!-- <div>
      {{ query }}
    </div> -->
  </div>
</template>

<script>
import { open_new_page, http, get_browser_id } from "@/utils/http";

export default {
  data() {
    return {
      loading: false,
      query: null,

      submit_loading: false,
      submit_status: 0,
      submit_error_txt: "",
    };
  },
  mounted() {
    var that = this;
    setTimeout(function () {
      var query = that.$route.query;
      console.log(query);
      that.query = query;
      that.click_bind();
    }, 2000);
  },
  methods: {
    click_bind() {
      var that = this;
      var obj = {
        code: this.query.code,
        state: this.query.state,
      };
      console.log(obj);
      this.submit_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/v2/h5_bind_wx",
        obj,
        false,
        "visitor"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.submit_status = 1;
            that.submit_loading = false;
          } else {
            that.submit_status = 2;
            that.submit_error_txt = res.msg;
            that.submit_loading = false;
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.bind2 {
  text-align: center;
  padding-top: 100px;
}

.bind2_name {
  margin: 20px 0 100px 0;
  font-weight: 650;
}

.logo2_div {
  padding-top: 50px;
  display: flex;
  justify-content: center;
}

.logo2 {
  height: 40px;
  opacity: 0.3;
}

.ab {
  color: #e7ec41;
}
.bind_btn {
  color: #fff;
  border-radius: 5px;
  width: 300px;
  width: 30%;
  height: 40px;
}

.bind_btn_div {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.pagemain {
  min-height: 100vh;
  background: #fff;
}

.bind_wx_title {
  padding: 15px 10px;
  height: 200px;
  color: #5e5e5e;
  border-radius: 5px;
  background: #fff;
  margin: 10px 20px;
}
</style>
